import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';
import { trackPageView } from '../utils/analytics';

const RECORDING_BLOCKED_PATHS = ['/restaurant', '/admin'];

const isRecordingBlocked = (pathname) =>
  RECORDING_BLOCKED_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname, location.search);
    posthog.capture('$pageview');
    window.fbq?.('track', 'PageView');

    if (isRecordingBlocked(location.pathname)) {
      posthog.stopSessionRecording();
    } else {
      posthog.startSessionRecording();
    }
  }, [location]);
};

export default usePageTracking;

